import { useMemo, useState } from "react";

const useTemplateSelectorDialog = () => {
    const [ isOpenTemplateSelectorDialog, setIsOpenTemplateSelectorDialog ] = useState(false);

    return useMemo(
        () => ({
            isOpenTemplateSelectorDialog,
            onOpenTemplateSelectorDialog: () => setIsOpenTemplateSelectorDialog(true),
            onCloseTemplateSelectorDialog: () => setIsOpenTemplateSelectorDialog(false)
        }),
        [ isOpenTemplateSelectorDialog ]
    );
};

export default useTemplateSelectorDialog;
